import { authFetch } from 'auth/utils';
import { Account, AccountsDTO, AccountsFilters } from '../models/accounts';
import { mapKeys, omitBy, upperFirst } from 'lodash';
import qs from 'qs';
import { envVariables } from 'src/common/utils/envVariables';

const prepareAccountsQuery = (filters?: AccountsFilters) => {
  if (!filters) {
    return '';
  }

  const cleanedFilters = omitBy(filters, (value) => {
    return !value;
  });

  const searchParams = mapKeys(cleanedFilters, (_, key) => upperFirst(key)) as Record<
    string,
    string
  >;

  return qs.stringify(searchParams);
};

export const fetchAccounts = async (filters?: AccountsFilters, signal?: AbortSignal) => {
  const urlQuery = prepareAccountsQuery(filters);
  const accountsResponse = await authFetch(
    `${envVariables.VITE_SIM_INVENTORY_ACCOUNTS_API}?${urlQuery.toString()}`,
    { signal },
  );

  const accounts: AccountsDTO = await accountsResponse.json();
  return accounts.items.map((account) => ({
    ...account,
    accountRef: account.accountRef.toString(),
  }));
};

export const fetchAccount = async (id?: string, signal?: AbortSignal) => {
  const accountResponse = await authFetch(`${envVariables.VITE_SIM_INVENTORY_ACCOUNTS_API}/${id}`, {
    signal,
  });

  const account: Account = await accountResponse.json();
  return account;
};
